const getters = {
  // avatar: state => state.user.avatar,
  // name: state => state.user.name
}
export default getters

